import { Component, Input } from '@angular/core';

import { TranslatePipe } from '../../../core/i18n/translate.pipe';

@Component({
  selector: 'app-loading-block',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div class="loading-block">
      {{ text | t }}
    </div>
  `,
  styles: [`
    .loading-block {
      padding: 24px;
      border: 1px dashed #d1d5db;
      border-radius: 12px;
      background: #ffffff;
      color: #4b5563;
    }
  `]
})
export class LoadingBlockComponent
{
  @Input()
  public text = 'common.loading';
}
